import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseLoginRequireAlert.module.scss';

interface Props {
  className?: string;
  labelType: string;
  onClick: () => void;
}

const PurchaseLoginRequireAlert = ({
  className,
  intl,
  labelType,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseLoginRequireAlert, className);

  return (
    <div className={classes}>
      <p className={css.PurchaseLoginRequireAlert__Paragraph}>
        {intl.formatMessage({
          id: `purchases.purchaseLoginRequireAlert.message1.${labelType}`,
        })}
      </p>
      <p className={css.PurchaseLoginRequireAlert__Paragraph}>
        <FormattedMessage
          id={'purchases.purchaseLoginRequireAlert.message2'}
          values={{
            createUser: (
              <a
                onClick={onClick}
                className={css.PurchaseLoginRequireAlert__Link}
              >
                {intl.formatMessage({
                  id: 'purchases.purchaseLoginRequireAlert.here',
                })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(PurchaseLoginRequireAlert);
